import { getAccessToken } from 'utils/auth';
import { PLAYER_API_URL } from 'utils/urls';

export async function animationPreferences(signal: AbortSignal, value?: boolean): Promise<boolean> {
  const token = getAccessToken();
  if (!token) throw new Error('Sign in to save your settings.');
  const response = await fetch(`${PLAYER_API_URL}/player/animation-preferences`, {
    method: value === undefined ? 'GET' : 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: value === undefined ? undefined : JSON.stringify({ reduceAnimations: value }),
    cache: 'no-store',
    signal
  });
  if (!response.ok) throw new Error('Unable to update animation settings. Please try again.');
  const result = await response.json();
  if (typeof result.reduceAnimations !== 'boolean')
    throw new Error('Invalid animation settings response.');
  return result.reduceAnimations;
}
